import type { SVGProps } from 'react'
const EmptyTableIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="266"
    height="157"
    viewBox="0 0 266 157"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_33997_34856)">
      <path d="M266 147.578H0V147.691H266V147.578Z" fill="#F7F7F7" />
      <path
        d="M239.346 154.824H221.727V154.937H239.346V154.824Z"
        fill="#F7F7F7"
      />
      <path
        d="M176.209 156.047H171.586V156.159H176.209V156.047Z"
        fill="#F7F7F7"
      />
      <path
        d="M221.195 150.645H210.986V150.757H221.195V150.645Z"
        fill="#F7F7F7"
      />
      <path
        d="M50.8858 151.398H27.9087V151.511H50.8858V151.398Z"
        fill="#F7F7F7"
      />
      <path
        d="M58.9935 151.398H55.626V151.511H58.9935V151.398Z"
        fill="#F7F7F7"
      />
      <path
        d="M119.78 153.301H69.9419V153.413H119.78V153.301Z"
        fill="#F7F7F7"
      />
      <path
        d="M126.089 127.491H23.36C21.6842 127.491 20.3223 126.338 20.3223 124.92V2.68088C20.3223 1.26227 21.6842 0.109375 23.36 0.109375H126.089C127.765 0.109375 129.127 1.26227 129.127 2.68088V124.92C129.127 126.338 127.765 127.491 126.089 127.491ZM23.36 0.221963C21.7587 0.221963 20.4553 1.32532 20.4553 2.68088V124.92C20.4553 126.275 21.7587 127.379 23.36 127.379H126.089C127.691 127.379 128.994 126.275 128.994 124.92V2.68088C128.994 1.32532 127.691 0.221963 126.089 0.221963H23.36Z"
        fill="#F7F7F7"
      />
      <path
        d="M241.161 127.491H138.432C136.756 127.491 135.394 126.338 135.394 124.92V2.68088C135.394 1.26227 136.756 0.109375 138.432 0.109375H241.161C242.837 0.109375 244.199 1.26227 244.199 2.68088V124.92C244.199 126.338 242.837 127.491 241.161 127.491ZM138.432 0.221963C136.83 0.221963 135.527 1.32532 135.527 2.68088V124.92C135.527 126.275 136.83 127.379 138.432 127.379H241.161C242.762 127.379 244.066 126.275 244.066 124.92V2.68088C244.066 1.32532 242.762 0.221963 241.161 0.221963H138.432Z"
        fill="#F7F7F7"
      />
      <path
        d="M133 156.498C189.968 156.498 236.15 153.782 236.15 150.433C236.15 147.083 189.968 144.367 133 144.367C76.0322 144.367 29.8506 147.083 29.8506 150.433C29.8506 153.782 76.0322 156.498 133 156.498Z"
        fill="#E6F2FE"
      />
      <path
        d="M221.53 14.8477H44.4697C40.1183 14.8477 36.5908 18.4005 36.5908 22.7831V136.8C36.5908 141.182 40.1183 144.735 44.4697 144.735H221.53C225.881 144.735 229.409 141.182 229.409 136.8V22.7831C229.409 18.4005 225.881 14.8477 221.53 14.8477Z"
        fill="white"
      />
      <path
        d="M221.53 145.025H44.4694C39.9687 145.025 36.3032 141.333 36.3032 136.8V22.7834C36.3032 18.2504 39.9687 14.5586 44.4694 14.5586H221.535C226.036 14.5586 229.701 18.2504 229.701 22.7834V136.8C229.701 141.333 226.036 145.025 221.535 145.025H221.53ZM44.4694 15.1373C40.2826 15.1373 36.8778 18.5665 36.8778 22.7834V136.8C36.8778 141.017 40.2826 144.446 44.4694 144.446H221.535C225.722 144.446 229.127 141.017 229.127 136.8V22.7834C229.127 18.5665 225.722 15.1373 221.535 15.1373H44.4694Z"
        fill="#66B0F6"
      />
      <path
        d="M101.133 46.9309L51.5441 46.5181C49.5687 46.5016 47.9533 48.0954 47.936 50.078L47.3845 113.385C47.3672 115.367 48.9546 116.988 50.93 117.004L100.519 117.417C102.495 117.433 104.11 115.84 104.127 113.857L104.679 50.5504C104.696 48.5678 103.109 46.9474 101.133 46.9309Z"
        fill="#F7F7F7"
      />
      <path
        d="M51.8267 23.2082C51.8267 24.6227 50.6883 25.764 49.2891 25.764C47.8899 25.764 46.7515 24.6174 46.7515 23.2082C46.7515 21.799 47.8899 20.6523 49.2891 20.6523C50.6883 20.6523 51.8267 21.799 51.8267 23.2082Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M68.5004 24.7008H56.0409C55.2216 24.7008 54.5566 24.0257 54.5566 23.2059C54.5566 22.3807 55.227 21.7109 56.0409 21.7109H68.5004C69.3196 21.7109 69.9846 22.3861 69.9846 23.2059C69.9846 24.031 69.3143 24.7008 68.5004 24.7008Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M128.563 24.0263H119.822C119.37 24.0263 119.008 23.6566 119.008 23.2065C119.008 22.7511 119.375 22.3867 119.822 22.3867H128.563C129.015 22.3867 129.376 22.7564 129.376 23.2065C129.376 23.662 129.009 24.0263 128.563 24.0263Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M148.178 24.0263H139.437C138.985 24.0263 138.623 23.6566 138.623 23.2065C138.623 22.7511 138.99 22.3867 139.437 22.3867H148.178C148.63 22.3867 148.992 22.7564 148.992 23.2065C148.992 23.662 148.625 24.0263 148.178 24.0263Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M167.793 24.0263H159.052C158.6 24.0263 158.238 23.6566 158.238 23.2065C158.238 22.7511 158.605 22.3867 159.052 22.3867H167.793C168.245 22.3867 168.606 22.7564 168.606 23.2065C168.606 23.662 168.239 24.0263 167.793 24.0263Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M187.413 24.0263H178.672C178.22 24.0263 177.858 23.6566 177.858 23.2065C177.858 22.7511 178.225 22.3867 178.672 22.3867H187.413C187.865 22.3867 188.227 22.7564 188.227 23.2065C188.227 23.662 187.86 24.0263 187.413 24.0263Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.7"
        d="M212.513 24.6551H199.287C198.494 24.6551 197.851 24.0068 197.851 23.2084C197.851 22.4101 198.494 21.7617 199.287 21.7617H212.513C213.305 21.7617 213.949 22.4101 213.949 23.2084C213.949 24.0068 213.305 24.6551 212.513 24.6551Z"
        fill="#C8C8C8"
      />
      <path
        d="M218.937 46.9348L169.348 46.522C167.373 46.5055 165.757 48.0993 165.74 50.0819L165.189 113.389C165.171 115.371 166.759 116.992 168.734 117.008L218.323 117.421C220.299 117.437 221.914 115.844 221.931 113.861L222.483 50.5543C222.5 48.5717 220.913 46.9513 218.937 46.9348Z"
        fill="#F7F7F7"
      />
      <path
        d="M159.687 46.9348L110.098 46.522C108.123 46.5055 106.507 48.0993 106.49 50.0819L105.939 113.389C105.921 115.371 107.509 116.992 109.484 117.008L159.073 117.421C161.049 117.437 162.664 115.844 162.681 113.861L163.233 50.5543C163.25 48.5717 161.663 46.9513 159.687 46.9348Z"
        fill="#F7F7F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_33997_34856">
        <rect width="266" height="157" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default EmptyTableIcon
